export const environment = {
  production: true,

  caasMedia: 'https://www.hdi-bancassurance.de/media/',
  preview: false,

  cloudNavigationUrl: 'https://hdi-navigationservice.e-spirit.cloud/navigation/release.38798e39-b7a8-4d74-afe9-03673de1e87b?language=de_DE',
  cloudContentUrl: 'https://hdi-caas-api.e-spirit.cloud/hdi-prod/38798e39-b7a8-4d74-afe9-03673de1e87b',
  cloudApiKey: 'e01398f0-57b7-4c9d-b4a3-42289d9539ce',
  publicSnapUrl: 'https://hdi.e-spirit.hosting/fs5webedit/live/live.js',
};
